import { render, staticRenderFns } from "./ProviderSettled.vue?vue&type=template&id=0377e6f4&scoped=true&"
import script from "./ProviderSettled.vue?vue&type=script&lang=js&"
export * from "./ProviderSettled.vue?vue&type=script&lang=js&"
import style0 from "./ProviderSettled.vue?vue&type=style&index=0&id=0377e6f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0377e6f4",
  null
  
)

export default component.exports